/**
 * Resolve the data source string for a given field name.
 * Resolution order: exact field match → group match → _default fallback.
 */
export function getDataSource(
  dataSources: Record<string, string> | null | undefined,
  fieldName: string,
): string {
  if (!dataSources) return "";

  // Direct field match
  if (dataSources[fieldName]) return dataSources[fieldName];

  // Group matches
  if (fieldName.startsWith("aa_") && dataSources["aa_profile"])
    return dataSources["aa_profile"];
  if (fieldName.startsWith("fa_") && dataSources["fatty_acids"])
    return dataSources["fatty_acids"];
  if (
    (fieldName === "fiber_insoluble" || fieldName === "fiber_soluble") &&
    dataSources["fiber_fractions"]
  )
    return dataSources["fiber_fractions"];
  if (fieldName === "resistant_starch" && dataSources["resistant_starch"])
    return dataSources["resistant_starch"];
  if (
    (fieldName === "ref_digest_product" ||
      fieldName === "ref_digest_value" ||
      fieldName === "ref_digest_source") &&
    dataSources["ref_digestibility"]
  )
    return dataSources["ref_digestibility"];
  if (fieldName === "bcaa_mg_per_g" && dataSources["bcaa_mg_per_g"])
    return dataSources["bcaa_mg_per_g"];

  // Fallback
  return dataSources["_default"] || "";
}
